import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';

const endpoint = 'ums/v1/crm/management/source-brand-location-attributes';

export type ILocationAttributeData = {
  id: number;
  key: string;
  value: any;
  createdAt: string;
  updatedAt: string;
};

type TData = {
  locationId: number;
  attributes: ILocationAttributeData[];
  total: number;
};

type TError = AxiosError;
type TQueryKey = [typeof endpoint, 'location', number];

type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetAttributesByLocationApi(locationId: number, options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();
  const toast = useCustomToast();
  const { ...otherOptions } = options || {};

  const queryFn = async () => {
    try {
      const { data } = await http.get(`${endpoint}/location/${locationId}`);
      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useQueryWrapper([endpoint, 'location', locationId], queryFn, {
    enabled: isLoggedIn && !!locationId,
    ...otherOptions,
  });
}
